import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { connect } from "react-redux"
import { Container, Row, Col } from "reactstrap"

import Img from "gatsby-image"

const OurTeam = ({ team }) => {
  
  let display = team.map((i, idx) => {
    return (
      <Col key={idx} xs="6" md="3" className="team-member">
        <Img className="image" fluid={i.image.fluid} />
        <Img
          className="image hover"
          fluid={i.imageHover.fluid}
        />
        {/*<Img className="image" fluid={data[i.img].childImageSharp.fluid} />*/}
        {/*<Img*/}
        {/*  className="image hover"*/}
        {/*  fluid={data[i.hover].childImageSharp.fluid}*/}
        {/*/>*/}
        <div id="name">{i.name}</div>
        <div id="title">{i.title}</div>
      </Col>
    )
  })
  return (
    <Container fluid id="ourTeam">
      <Row className="team-row">{display}</Row>
      <Row className="pt-5 pb-4 tex-center">
        <Col className="text-center credit">
          Illustrations by{" "}
          <a
            href="https://www.instagram.com/rhymezlikedimez/"
            target="_blank"
            rel="noreferrer noopener"
          >
            @rhymezlikedimez
          </a>
        </Col>
      </Row>
    </Container>
  )
}

export default connect(state => ({}), null)(OurTeam)
